import type { ReactNode } from "react";
import "./section.css";

export function Section({
  id,
  title,
  subtitle,
  ariaLabel,
  children
}: {
  id: string;
  title?: string;
  subtitle?: string;
  ariaLabel?: string;
  children: ReactNode;
}) {
  return (
    <section id={id} aria-label={ariaLabel ?? title} className="section">
      <div className="section__inner" data-reveal>
        {title ? (
          <header className="section__header">
            <h2 className="section__title">{title}</h2>
            {subtitle ? <p className="section__subtitle">{subtitle}</p> : null}
          </header>
        ) : null}
        <div className="section__content">{children}</div>
      </div>
    </section>
  );
}

